import { Directive, ElementRef, Input } from '@angular/core'

@Directive({
  selector: '[srLabel]',
})
export class SRLabelDirective {
  @Input() placeholder?: string
  @Input('srLabel') label?: string
  @Input() id: string

  constructor (
    private element: ElementRef<HTMLElement>,
  ) { }

  ngOnInit () {
    if (!this.id) {
      console.error('id attribute not set on element', this.element.nativeElement)
    }
    if (!this.label && !this.placeholder) {
      console.error('Neither label not placeholder attributes set on element', this.element.nativeElement)
    }

    const label = document.createElement('label')
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    label.innerText = (this.label || this.placeholder) ?? ''
    label.classList.add('sr-only')
    label.setAttribute('for', this.id)
    this.element.nativeElement.parentNode?.insertBefore(
      label,
      this.element.nativeElement.nextSibling,
    )
  }
}
